module.exports = __webpack_public_path__ + "img/biaoqian_gonggongyulechangsuo.47292543.png";